export default "__VITE_ASSET__CIK$Uzw1__"